<template>
    <div>
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'TRX Recharge'"></navTitle>
        <div class="recharge-list">
            <div class="amount" :class="{ 'active': active === k}" v-for="(v,k) in recharge_list"
                 @click="choseAmount(k)">Rp{{v}}
            </div>
        </div>
        <div class="exchange-rate">1<i> Rp</i> ≈ {{exchange_rate}}<i> TRX</i></div>
        <div class="y_money">≈ {{Math.round(money*exchange_rate)}}<label> TRX</label></div>
        <div class="bg-color-blue" @click="TRXTobalance">Tentu</div>
    </div>
</template>

<script>
    import navTitle from "@components/navTitle"
    import {getExchangeRate} from "../../api/trx"

    export default {
        name: "trx-recharge",
        components: {navTitle},
        data() {
            return {
                active: 1,
                exchange_rate: 0,
                money: 50000,
                recharge_list: [20000, 50000, 100000, 200000, 500000, 1000000, 2000000, 5000000, 10000000, 20000000]
            }
        },
        created() {
            this.getExchangeRate()
        },
        methods: {
            getExchangeRate() {
                let that = this
                getExchangeRate({type: 1}).then(res => {
                    that.exchange_rate = res.data.current_rate
                    console.log(res)
                }).catch(err => {
                    console.log(err)
                })
            },
            choseAmount(k) {
                this.active = k
                this.money = this.recharge_list[k]
            },
            TRXTobalance() {
                this.$router.push({
                    path: '/user/Recharge_cash_info',
                    query: {amount: this.money, money_trx: Math.round(this.money * this.exchange_rate)}
                })
            }
        }
    }
</script>

<style scoped>
    .recharge-list {
        width: 100%;
        margin-top: 1rem;
        padding-top: .2rem;
    }

    .amount {
        text-align: center;
        width: 50%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 50px;
        height: 50px;
        color: #333;
        font-size: 0.36rem;
        float: left;
        transform: scale(0.9);
    }

    .active {
        border: 2px solid #00c3f9 !important;
        color: #00c3f9 !important;
        font-weight: bold;
    }

    .exchange-rate {
        text-align: center;
        color: red;
        font-size: .25rem;
    }

    .exchange-rate i {
        font-size: .1rem;
    }

    .y_money {
        text-align: center;
        font-weight: bold;
        color: #00c3f9 !important;
        margin-top: .1rem;
    }

    .y_money label {
        font-size: .1rem;
    }

    .bg-color-blue {
        color: #fff;
        margin: .3rem 2%;
        width: 96%;
        text-align: center;
        font-size: .5rem;
        padding: .1rem 0;
        border-radius: .1rem;
    }
</style>